import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-header-subtitle">
                    <b>
                        We automatically cluster all your GSC keywords receiving 10 or more clicks
                        each week.
                    </b>{' '}
                    Cluster names are generated by selecting the shortest keyword in each group and
                    alphabetically rearranging the words to create a label. Some names may appear
                    misspelled or abbreviated — these reflect how users searched in Google, as
                    reported by GSC. The cluster name is simply a label and not meant to be
                    grammatically correct.
                </div>
            </>
        );
    }
}

export default ExtraButtons;
